import { IBookingDetailsDialogHashMatches } from '..';
import { useHashRouteContext } from '../../../../../shared/components/hash-route';

export const useCurrentBookingReference = () => {
	const {
		matches: { reference },
	} = useHashRouteContext<IBookingDetailsDialogHashMatches>();

	return reference;
};
